import React from "react";
import data from "../../json/ProjectManagement/section3.json";

const Section3 = () => {
  return (
    <div className="w-full flex justify-center bg-section3">
      <div className="2xl:container p-4 lg:px-20 py-12 items-center flex flex-col gap-[64px]">
        <div className="w-5/6 flex justify-center text-28 text-center md:text-left md:text-32 lg:text-40 text-21273D">
          <h1 className="text-center">{data.Title}</h1>
        </div>
        <div className="w-11/12 flex flex-col gap-4 lg:flex-row relative h-fit lg:h-[512px]">
          <div className="w-full lg:w-[55%] p-10 border-[1px] border-DBD6D0 rounded-[32px] lg:rounded-tl-[32px] lg:rounded-bl-[32px] flex flex-col z-0 bg-white">
            <h1 className="text-28 md:text-32 text-normal">
              {data.Journals.Title}
            </h1>
            <div className="mt-6 flex flex-col gap-4 md:pr-[60px]">
              {data.Journals.Points.map((pt, i) => (
                <div key={i} className="flex gap-4">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/Herosection/rightarrow.svg"
                    }
                    alt="."
                  />
                  <p className="text-base md:text-18 text-approachblk">{pt}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-[52%] p-10 border-[1px] border-highlight rounded-[32px] flex flex-col z-10 lg:absolute right-0 bg-white">
            <h1 className="text-28 md:text-32 text-normal">
              {data.Books.Title}
            </h1>
            <div className="mt-6 flex flex-col gap-4">
              {data.Books.Points.map((pt, i) => (
                <div key={i} className="flex gap-4">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/Herosection/rightarrow.svg"
                    }
                    alt="."
                  />
                  <p className="text-base md:text-18 text-approachblk">{pt}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
